<template>
  <div class="">
    <modal :show="showModal" modal-classes="modal-secondary" size="lg">
      <h3 class="text-center">
        {{ $t("PROPERTY_TRANSACTIONS.PAYMENT_OPERATION") }}
      </h3>
      <form class="add-form pb-2" @submit.prevent="">
        <div class="form-wrapper">
          <base-input
            :label="`${$t('PROPERTIES_PAYMENTS.ATTENTION')} (*)`"
            :placeholder="$t('PROPERTIES_PAYMENTS.ATTENTION')"
            v-model="propertiesPaymentsModel.attention"
            type="text"
          >
          </base-input>
          <validation-error :errors="apiValidationErrors.customer" />
        </div>
        <div class="form-wrapper">
          <base-input
            :label="`${$t('PROPERTIES_PAYMENTS.EMAIL')}`"
            :placeholder="$t('PROPERTIES_PAYMENTS.EMAIL')"
            v-model="propertiesPaymentsModel.email"
            type="text"
          >
          </base-input>
        </div>
        <div class="form-wrapper full">
          <property-payment-inputs
            :totalDue="totalDue"
            @transactionsChanged="
              (paymentsData) => {
                paymentsModel = paymentsData;
              }
            "
          />
        </div>

        <div class="form-wrapper full">
          <base-input
            :label="`${$t('PROPERTIES_PAYMENTS.DATE')} (*)`"
            :placeholder="$t('PROPERTIES_PAYMENTS.DATE')"
            type="number"
          >
            <flat-picker
              :placeholder="$t('PROPERTIES_PAYMENTS.DATE')"
              :config="{
                allowInput: true,
                enableTime: false,
                type: 'date',
                maxDate: 'today',
                locale: $flatPickrLocale(),
                disable: [
                  function (date) {
                    return date.getDay() === 0;
                  },
                ],
              }"
              class="form-control datepicker"
              v-model="propertiesPaymentsModel.date"
            >
            </flat-picker>
          </base-input>
          <validation-error :errors="apiValidationErrors.date" />
        </div>

        <div class="form-wrapper full">
          <base-input
            :label="$t('PROPERTIES_PAYMENTS.EXCERPT')"
            :placeholder="$t('PROPERTIES_PAYMENTS.EXCERPT')"
          >
            <html-editor
              v-model="propertiesPaymentsModel.excerpt"
              @change="onFormChanged()"
            >
            </html-editor>
          </base-input>
          <validation-error :errors="apiValidationErrors.excerpt" />
        </div>
      </form>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-primary"
          @click="handleSubmit"
          :disabled="loading"
        >
          <span v-if="loading" class="btn-inner--icon">
            <i class="fas fa-spinner fa-spin"></i>
          </span>
          {{ $t("COMMON.SAVE") }}
        </button>

        <button
          type="button"
          class="btn btn-link ml-auto"
          @click="closeModal"
          :disabled="loading"
        >
          {{ $t("COMMON.CLOSE") }}
        </button>
      </template>
    </modal>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import { Button, Option, Select } from "element-ui";
import formMixin from "@/mixins/form-mixin";
import requestErrorMixin from "@/mixins/request-error-mixin";
import ValidationError from "@/components/ValidationError.vue";
import PropertyPaymentInputs from "@/components/PropertyPaymentInputs.vue";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import HtmlEditor from "@/components/Inputs/HtmlEditor";
import defaultPropertiesPayment from "../../PropertiesPaymentManagement/defaultPropertiesPayment";

export default {
  name: "property-transaction-form",

  components: {
    ValidationError,
    PropertyPaymentInputs,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
    HtmlEditor,
  },

  mixins: [formMixin, requestErrorMixin],

  props: ["property", "showModal", "formErrors"],

  data() {
    let propertiesPaymentData = cloneDeep(defaultPropertiesPayment);
    propertiesPaymentData.organization = this.property.organization;
    return {
      loading: false,
      propertiesPaymentsModel: propertiesPaymentData,
      paymentsModel: [],
      totalDue: (this.property.total.toFixed(2) - this.property.total_paied.toFixed(2)).toFixed(2),
      refundAmount: 0,
      showRefundAmount: false,
      dataReceipt: {
        email: "",
        attention: "",
        amount: null,
        excerpt: "",
        date: null,
        ids: []
      }
    };
  },

  computed: {},

  created(){
    this.paymentsModel = [];
  },

  methods: {
    async handleSubmit() {
      this.loading = true;
      let totalPayment = this.paymentsModel.reduce((sum, item) => sum + parseFloat(item.amount), 0);
      let totalToPay = Math.round((this.property.total-this.property.total_paied) * 100) / 100;
      let paymentsData = cloneDeep(this.paymentsModel);
      paymentsData = paymentsData.filter(
        (item) => !!item.amount && item.source
      );
      if(!this.propertiesPaymentsModel.date || this.propertiesPaymentsModel.date == ""){
        this.loading = false;
        this.$notify({
          type: "danger",
          message: this.$t("PROPERTIES_PAYMENTS.EMPTY_DATE"),
        });
        this.loading = false;
        return;
      }
      try {
        const hasInvalidSource = this.paymentsModel.some(
          (payment) => payment.source === null || payment.source === ""
        );
        if(hasInvalidSource){
          this.$notify({
            type: "danger",
            message: this.$t("ERRORS.INVALID_SOURCE"),
          });
          this.loading = false;
          return;
        }
        if(this.propertiesPaymentsModel.email && this.propertiesPaymentsModel.email != "" && !this.isValidEmail(this.propertiesPaymentsModel.email)){
          this.$notify({
            type: "danger",
            message: this.$t("ERRORS.INVALID_EMAIL"),
          });
          this.loading = false;
          return;
        }
        for (const payment of paymentsData) {
          const propertiesPaymentData = cloneDeep(this.propertiesPaymentsModel);
          propertiesPaymentData.amount = payment.refund ? -payment.amount : payment.amount;
          propertiesPaymentData.source = payment.source;
          delete propertiesPaymentData.propertiesPaymentsProperties;

          await this.$store.dispatch(
            "propertiesPayments/add",
            propertiesPaymentData
          );
          const propertiesPayment =
            this.$store.getters["propertiesPayments/propertiesPayment"];
            console.log('this.dataReceipt.attention', this.dataReceipt.attention);
          //if(!this.dataReceipt.attention || this.dataReceipt.attention == ""){
          this.dataReceipt.attention = propertiesPayment.attention;
          this.dataReceipt.email = propertiesPayment.email;
          this.dataReceipt.amount = propertiesPayment.amount;
          this.dataReceipt.date = propertiesPayment.date;
          this.dataReceipt.excerpt = propertiesPayment.excerpt;
          this.dataReceipt.ids.push(propertiesPayment.id);
          //}

          await this.$store.dispatch("propertiesPaymentsProperties/add", {
            type: "properties-payments-properties",
            amount: payment.amount,
            property_type: "App\\Models\\Property",
            property: this.property,
            propertiesPayment: propertiesPayment,
            relationshipNames: ["property", "propertiesPayment"],
          });
        }

        if(this.dataReceipt.email && this.dataReceipt.email != ""){
          await this.$store.dispatch(
            "propertiesPayments/sendMailReceipt", this.dataReceipt
          );
        }
        this.property.total_paied+=totalPayment;
        if(parseFloat(this.property.total_paied).toFixed(2) == parseFloat(this.property.total).toFixed(2)){
          await this.$store.dispatch("properties/cancel", {id : this.property.id});
        }
        this.$notify({
          type: "success",
          message: this.$t("PROPERTIES_PAYMENTS.PROPERTIES_PAYMENT_ADDED"),
        });
        this.loading = false;
        this.$emit("onTransactionAdded", true);
        this.closeModal(true);
      } catch (error) {
        console.log(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
    isValidEmail(email) {
      // Regex pour valider le format de l'email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    closeModal(refresh = false) {
      this.$emit("onCloseModal", refresh, this.property);
    },
  },

  mounted() {},

  watch: {},
};
</script>
